module.exports = __webpack_public_path__ + "img/imagen_parrafo_3.0f629ff0.png";